import React from "react";
import HomeSVG from "@src/assets/HomeSVG";
import ArticleSVG from "@src/assets/ArticleSVG";
import MusicNoteSVG from "@src/assets/MusicNoteSVG";
import AddUser from "@src/assets/img/add-user-svg.svg";
import CalendarIcon from "@src/assets/img/calendar.svg";
import ScheduleBoardIcon from "@src/assets/img/schedule-board.svg";
import VinylIcon from "@src/assets/img/vinyl-record.svg";
import {
  Activity,
  Smile,
  TagIcon,
  ReceiptText,
  Share2,
  Users,
  MessageSquare,
  MessagesSquare,
} from "lucide-react";
import { theme } from "@src/theme";

export const renderRouteIcon = ({
  active,
  route,
  title,
  isSideNav = false,
}: {
  active: boolean;
  route: string;
  title: string;
  isSideNav?: boolean;
}): React.JSX.Element => {
  switch (route) {
    case "/":
      return <HomeSVG $size={active ? 14 : 18} $active={active} />;
    case "/library":
      return <MusicNoteSVG $size={active ? 14 : 18} $active={active} />;
    case "/messages":
      return (
        <MessageSquare
          size={active ? 14 : 18}
          style={{ color: active ? theme.colors.yellow : theme.colors.black }}
        />
      );
    case "/guest-curator":
      return (
        <img
          src={AddUser}
          alt="Add user"
          style={{
            width: "100%",
            objectFit: "contain",
            userSelect: "none",
            filter: active
              ? "brightness(0) saturate(100%) invert(84%) sepia(100%) saturate(280%) hue-rotate(2deg) brightness(103%) contrast(100%)"
              : "none",
            color: "#FFF057",
          }}
        />
      );
    case "/schedule-calendar":
      return (
        <img
          src={CalendarIcon}
          alt="Calendar"
          style={{
            width: "100%",
            objectFit: "contain",
            userSelect: "none",
            filter: active
              ? "brightness(0) saturate(100%) invert(84%) sepia(100%) saturate(280%) hue-rotate(2deg) brightness(103%) contrast(100%)"
              : "none",
            color: "#FFF057",
          }}
        />
      );
    case "/schedule-board":
      return (
        <img
          src={ScheduleBoardIcon}
          alt="Schedule Board"
          style={{
            width: "100%",
            objectFit: "contain",
            userSelect: "none",
            filter: active
              ? "brightness(0) saturate(100%) invert(84%) sepia(100%) saturate(280%) hue-rotate(2deg) brightness(103%) contrast(100%)"
              : "none",
            color: "#FFF057",
          }}
        />
      );
    case "/tag-factory":
      return (
        <TagIcon
          size={active ? 14 : 18}
          style={{ color: active ? theme.colors.yellow : theme.colors.black }}
        />
      );
    case "/mood-factory":
      return (
        <Smile
          size={active ? 14 : 18}
          style={{ color: active ? theme.colors.yellow : theme.colors.black }}
        />
      );
    case "/vinyl-list":
      return (
        <img
          src={VinylIcon}
          alt="Vinyl List"
          style={
            isSideNav && !active
              ? { filter: "grayscale(100%) opacity(0.6)" }
              : {}
          }
        />
      );
    case "/articles":
      return <ArticleSVG $size={active ? 14 : 18} $active={active} />;
    case "/invoices":
      return (
        <ReceiptText
          size={active ? 14 : 18}
          style={{ color: active ? theme.colors.yellow : theme.colors.black }}
        />
      );
    case "/social-media-promo":
      return (
        <Share2
          size={active ? 14 : 18}
          style={{ color: active ? theme.colors.yellow : theme.colors.black }}
        />
      );

    case "/curator-management":
      return (
        <img
          src={AddUser}
          alt="Curator Management"
          style={{
            width: "100%",
            objectFit: "contain",
            userSelect: "none",
            filter: active
              ? "brightness(0) saturate(100%) invert(84%) sepia(100%) saturate(280%) hue-rotate(2deg) brightness(103%) contrast(100%)"
              : "none",
            color: "#FFF057",
          }}
        />
      );
    case "/clients-export":
      return (
        <Users
          size={active ? 14 : 18}
          style={{ color: active ? theme.colors.yellow : theme.colors.black }}
        />
      );
    case "/admin-messages":
      return (
        <MessagesSquare
          size={active ? 14 : 18}
          style={{ color: active ? theme.colors.yellow : theme.colors.black }}
        />
      );
    case "/status-check":
      return (
        <Activity
          size={active ? 14 : 18}
          style={{ color: active ? theme.colors.yellow : theme.colors.black }}
        />
      );
    default:
      return <span>{title}</span>;
  }
};
